import { Anchor, Button, CopyButton, Stack, Text, Textarea } from "@mantine/core";
import { Link } from "react-router";
import { env } from "../env";
import { PANEL_COLOR, PANEL_SPACE } from "../ui/tokens";
import { AuthCard } from "./AuthCard";

/** For tenants that block user consent to apps (firm-model spec §11): what to ask IT for,
 * and the admin-consent link that approves SlideBrain for the whole organization. */
export function adminConsentUrl(clientId: string): string {
  return `https://login.microsoftonline.com/organizations/adminconsent?client_id=${encodeURIComponent(clientId)}`;
}

export function AdminConsentPage() {
  const url = env.entraClientId ? adminConsentUrl(env.entraClientId) : null;
  return (
    <AuthCard title="Ask your IT admin to approve SlideBrain">
      <Stack gap={8}>
        <Text fw={600} lh={1.25}>
          For users:
        </Text>
        <Text lh={1.25}>
          Some organizations only let people sign in to apps their IT admin has approved. If "Continue with Microsoft" says
          you need admin approval, send your IT admin this page.
        </Text>
        <Text lh={1.25}>
          Until then, you can sign in with a one-time code sent to your work email.{" "}
          <Anchor component={Link} to="/sign-in" fw={400}>
            Back to sign-in.
          </Anchor>
        </Text>
      </Stack>
      <Stack gap={8}>
        <Text fw={600} lh={1.25}>
          For IT admins:
        </Text>
        <Text lh={1.25}>
          SlideBrain asks Microsoft only for your name and email address, to sign you in. It can't read your mail, files or
          calendar.
        </Text>
        {url ? <Text lh={1.25}>You can approve SlideBrain for your organization here:</Text> : null}
      </Stack>
      {url ? (
        <Stack gap={PANEL_SPACE.field}>
          <Textarea aria-label="Admin approval link" value={url} readOnly autosize minRows={2} styles={{ input: { color: PANEL_COLOR.textSecondary } }} />
          <CopyButton value={url}>{({ copied, copy }) => <Button onClick={copy}>{copied ? "Copied" : "Copy the link"}</Button>}</CopyButton>
        </Stack>
      ) : null}
    </AuthCard>
  );
}
